import type { TFunction } from "i18next";
import U2000InputText from "../../../../u2000Core/components/formControls/input/U2000InputText";
import U2000CheckBox from "../../../../u2000Core/components/formControls/checkbox/U2000CheckBox";
import U2000Panel from "../../../../u2000Core/components/layout/U2000Panel";
import { U2000FormStateEnumEditMode } from "../../../../u2000Core/reducer/formReducer/U2000FormState";
import type { U2000FormStateHandlers } from "../../../../u2000Core/reducer/formReducer/U2000FormStateHandlers";
import { NS } from "../../../U3121";
import type { U3121SubProject } from "../../../U3121Service";

interface U3121SubProjectBodyProps {
  formStateHandlers: U2000FormStateHandlers<U3121SubProject>;
  t: TFunction;
}

/**
 * Panneau Informations générales du sous-projet.
 * Seuls les champs propres au sous-projet (numéro, nom, statut) sont affichés ici.
 * Profil de facturation, assignation employé et assignation tâche sont gérés dans leurs onglets dédiés.
 */
function U3121SubProjectBody({ formStateHandlers, t }: U3121SubProjectBodyProps) {
  const editMode = formStateHandlers.getFormEditMode();

  return (
    <U2000Panel title={t("lblGeneralInfo", { ns: NS })}>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <U2000InputText
          formStateHandlers={formStateHandlers}
          fieldName="subProjetNumber"
          label={t("lblSubProjetNumber", { ns: NS })}
          required
          readonly={editMode === U2000FormStateEnumEditMode.EDIT}
        />
        <div className="flex items-center gap-4">
          <div className="flex-1 min-w-0">
            <U2000InputText formStateHandlers={formStateHandlers} fieldName="subProjetName" label={t("lblSubProjetName", { ns: NS })} required />
          </div>
          <div className="shrink-0 self-center pt-6">
            <U2000CheckBox formStateHandlers={formStateHandlers} fieldName="subProjectStatus" label={t("valActive", { ns: NS })} readonly />
          </div>
        </div>
      </div>
    </U2000Panel>
  );
}

export default U3121SubProjectBody;
